import React from "react";
import { dashboardIcon } from "../../assets/img";

function Application({ isDataAllCard }) {
  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontWeight: "600",
      fontSize: "14px", // smaller
      lineHeight: "20px",
      color: "#A7A7A7",
    },
    value: {
      fontFamily: "Open Sans",
      fontWeight: "600",
      fontSize: "16px", // smaller
      lineHeight: "22px",
      color: "#222227",
    },
  };

  const dataItems = [
    { label: "Total User", value: isDataAllCard?.application?.total_user },
    {
      label: "Total Customers",
      value: isDataAllCard?.application?.total_customers,
    },
    { label: "Total Owner", value: isDataAllCard?.application?.total_owner },
    {
      label: "Total Receptionist",
      value: isDataAllCard?.application?.total_receptionist,
    },
  ];

  return (
    <div
      style={{
        padding: 14, // smaller
        width: "100%",
        background: "#FFFFFF",
        boxShadow: "0px 1px 8px rgba(0,0,0,0.1)",
        borderRadius: "8px", // smaller
      }}
    >
      <p
        style={{
          fontWeight: "700",
          fontSize: "15px", // smaller
          lineHeight: "20px",
          color: "#222227",
          marginBottom: 12, // smaller
        }}
      >
        Application
      </p>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "12px", // smaller
        }}
      >
        {dataItems.map((item, idx) => (
          <div
            key={idx}
            style={{
              border: "1px solid #EEEEEE",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "16px",
              padding: "10px 16px", // smaller
              width: "48%",
              marginBottom: 8, // smaller
            }}
          >
            <div>
              <p
                style={{
                  fontSize: "16px", // smaller
                  fontWeight: "400",
                  color: "#9ca3af",
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                {item.label}
              </p>
              <p style={{ fontSize: "22px", fontWeight: "bold", margin: 0 }}>
                {(item.value || 0).toFixed(2)}
              </p>
            </div>
            <div style={{ width: "26px", height: "26px" }}>
              <img
                src={dashboardIcon}
                alt=""
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Application;
